export const CountryDropdownBuilderComponent = {
  name: '_CountryDropdown_',
  inputs: [],
} as const;

export default CountryDropdownBuilderComponent;
